module.exports = __webpack_public_path__ + "img/face2face.9a5129a2.svg";